import {useTranslation} from 'react-i18next'

import {createBaseDialogState, DialogNew} from '@sdox/ui'

import {FormWrapper} from './FormWrapper'

import type {XcDisclaimerInterfaceFragment} from '@sdox/api'

export const useCreateOrUpdateDisclaimerDialogStore = createBaseDialogState<XcDisclaimerInterfaceFragment>()

export const CreateOrUpdateDisclaimerDialog = () => {
  const {isLoading, isDialogOpen, closeDialog} = useCreateOrUpdateDisclaimerDialogStore()

  const {t} = useTranslation()

  return (
    <DialogNew
      heading={t('common:createItem', {item: 'Disclaimer'})}
      open={isDialogOpen}
      onClose={closeDialog}
      persistent={isLoading}
    >
      <FormWrapper />
    </DialogNew>
  )
}
